<div class="si-check {{styleClass}}" [class.disabled]="disabled" siProvideParentForm
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)">
  <label for="si-check-{{id}}" [tabindex]="disabled ? '-1' : '0'">
    <ng-container *ngTemplateOutlet="preCheckContent"></ng-container>
    <input #formModel="ngModel"
           type="checkbox"
           id="si-check-{{id}}"
           name="{{name}}"
           [ngModel]="model"
           (ngModelChange)="onChangeModel($event)"
           siValidation="{{rule}}"
           [siValidationElement]="validationElement"
           [siValidationExternalErrorText]="validationExternalErrorText">
    <div class="si-check_check">
      <div class="si-check_check_focus"></div>
    </div>
    <span *ngIf="text"
          class="si-check_label"
          [translate]="text"
    ></span>
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="si-check_validation"
    ></si-validation-element>
    <i *ngIf="tooltipText"
       class="si-check_icon-tooltip"
       [ngClass]="tooltipIcon"
       pTooltip="{{tooltipText | translate}}"
       tooltipPosition="{{tooltipPosition}}"
    ></i>
  </label>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
